import { TOGGLE_DIALOG } from '../actions/dialogs.actions';

const initialState = {
  userProfile: false
};

const dialogsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case TOGGLE_DIALOG:
      return { ...state, [payload]: !state[payload] };
    default:
      return state;
  }
};

export default dialogsReducer;
